import React, { FC, ReactNode } from 'react';
import styled from '@emotion/styled';
import { ChartPopover } from './tooltip/ChartPopover';

interface ChartPlaceholderProps {
  title: ReactNode;
  popoverText: ReactNode;
  message: ReactNode;
}

const ChartPlaceholderTitle = styled.h4`
  color: #566072;
  font-size: 1.25rem;
  font-weight: normal;
  margin: 0;
  padding-left: 1.5rem;
`;
const ChartPlaceholderMessage = styled.h4`
  color: #566072;
  font-size: 1rem;
  font-weight: normal;
  margin: 0;
  margin-left: 0.5rem;
  letter-spacing: 0.14px;

  & a {
    color: #007db8;
    font-weight: 500;
    text-decoration: none;
  }
`;
const ChartPlaceholderWrapper = styled.div`
  display: flex;
  background-color: #ffffff;
  align-items: flex-end;
  padding-top: 0.75rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #f5f6fb;
`;

const PopoverWrapper = styled.span`
  color: #566072;
`;

const ChartPlaceholder: FC<ChartPlaceholderProps> = props => {
  return (
    <ChartPlaceholderWrapper>
      <ChartPlaceholderTitle>{props.title}</ChartPlaceholderTitle>
      <ChartPopover>
        <PopoverWrapper>{props.popoverText}</PopoverWrapper>
      </ChartPopover>
      <ChartPlaceholderMessage>{props.message}</ChartPlaceholderMessage>
    </ChartPlaceholderWrapper>
  );
};

export { ChartPlaceholder, ChartPlaceholder as default };
